import axiosInstance from '../../util/axiosAPI';
import { API_URL } from '../../config';

export default class SystemService {

    constructor() { }

    async storage() {
        const url = `${API_URL}/api/system/storage/`;
        return axiosInstance.get(url).then(response => response.data);
    }
}